import React from 'react';

export default function TableRowData({ status, interfaceName, children }) {
  let className = '';
  if (typeof status == 'boolean' || status == 'true' || status == 'false') {
    className = status === 'true' || status === true ? 'fill-status-success' : 'fill-status-danger';
  }
  return (
    <td rowSpan={interfaceName === 'dns' ? 3 : 1}>
      {children ? (
        <div className=" serial-number-input-td">{children}</div>
      ) : (
        <div className={`ful-fill-status  ${className}`} />
      )}
    </td>
  );
}
